var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdf-container"},[_c('iframe',{attrs:{"src":`/static/pdfjs-2.4.456-dist/web/viewer.html?file=${encodeURIComponent(_vm.src)}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }